import { useEffect } from "react";
import { useSelector } from "react-redux";
import { State } from "../../app/store";

type ThemeMode = "light" | "dark";

export function useThemeMode() {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  // Dark mode jest ustawiany globalnie w konfiguracji (darkMode: boolean)
  const themeMode: ThemeMode = saleConfiguration?.darkMode ? "dark" : "light";

  useEffect(() => {
    applyTheme(themeMode, saleConfiguration?.backgroundColor);
  }, [themeMode, saleConfiguration?.backgroundColor]);

  // Dla kompatybilności z kontekstem
  return { themeMode };
}

function applyTheme(mode: ThemeMode, configBackground?: string) {
  const root = document.documentElement;

  if (mode === "dark") {
    // Dark mode - kolory odwrócone
    root.style.setProperty("--surface-dark", "#FCFCFC");
    root.style.setProperty("--surface-dark-gray", "#F8F8F8");
    root.style.setProperty("--surface-light-gray", "#464646");
    root.style.setProperty("--surface-light", "#181818");
    root.style.setProperty("--surface-white", "#1A1A1A");

    root.style.setProperty("--text-dark", "#FAFAFA");
    root.style.setProperty("--text-dark-gray", "#d1d1d1");
    root.style.setProperty("--text-light-gray", "#676767");
    root.style.setProperty("--text-light", "#0B0B0B");

    // Dark mode background - klient ustawia to samo tło co w light mode,
    // lub definiuje osobne tło dla dark mode w konfiguracji
    // Na razie używamy tego samego koloru z konfiguracji (backgroundColor)
    const darkBg = configBackground || "#1A1A1A";
    root.style.setProperty("--background-color-global", darkBg);

    root.setAttribute("data-theme", "dark");
  } else {
    // Light mode - domyślne wartości
    root.style.setProperty("--surface-dark", "#181818");
    root.style.setProperty("--surface-dark-gray", "#464646");
    root.style.setProperty("--surface-light-gray", "#F8F8F8");
    root.style.setProperty("--surface-light", "#FCFCFC");
    root.style.setProperty("--surface-white", "#ffffff");

    root.style.setProperty("--text-dark", "#0B0B0B");
    root.style.setProperty("--text-dark-gray", "#4B4B4B");
    root.style.setProperty("--text-light-gray", "#b1b1b1");
    root.style.setProperty("--text-light", "#FAFAFA");

    // Light mode background - ustawiany z konfiguracji
    const lightBg = configBackground || "#FAFAFA";
    root.style.setProperty("--background-color-global", lightBg);

    root.setAttribute("data-theme", "light");
  }
}
